import {
  SetupPage,
  TabPermission,
} from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { BrandSettings } from '../../../brand-settings.setup';

const parent: SetupPage = BrandSettings.pages.notifications;
const path = 'automatic';
const title = 'PAGE.BRAND_SETTINGS.NOTIFICATIONS.AUTOMATIC.TITLE';
const res = [];

export const BrandSettingsNotificationsAutomaticTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
